"use client";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useTemplateComponents } from "components/Resume/templateUtils";
import { cx } from "lib/cx";
import { useAppSelector } from "lib/redux/hooks";
import { selectResume } from "lib/redux/resumeSlice";
import { selectSettings } from "lib/redux/settingsSlice";
import { useState } from "react";
import MobileTemplatesPreviewCarousel from "./MobileTemplatesPreviewCarousel";

interface MobileReusmeTemplatesProps {
  setOpenTemplatesPreview: (visible: boolean) => void;
}

const MobileResumeTemplates = ({
  setOpenTemplatesPreview,
}: MobileReusmeTemplatesProps) => {
  const resume = useAppSelector(selectResume);
  const settings = useAppSelector(selectSettings);
  const { templateList } = useTemplateComponents(resume, settings);
  const [isExitingPreview, setIsExitingPreview] = useState(false); // State to handle exit animation
  const [isEnteringPreview, setIsEnteringPreview] = useState(true); // State to handle entry animation

  const handleClose = () => {
    setIsExitingPreview(true); // Trigger the exit animation
    setTimeout(() => {
      setOpenTemplatesPreview(false); // Remove the preview after animation
      setIsExitingPreview(false); // Reset exit state
    }, 500); // Adjust timing based on animation duration
  };

  return (
    <section
      className={cx(
        "fixed z-[110] h-1/2 w-full bg-[#d1d1d1] shadow-lg lg:hidden",
        "bottom-0",
        isExitingPreview && "fade-out-bottom", // Fade out to bottom when exiting
        isEnteringPreview && "fade-in-bottom" // Fade in bottom when entering
      )}
      id="mobile-templates-preview"
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <div className="absolute -top-3 left-1/2 h-6 w-6 -translate-x-1/2 rounded-full bg-[#3c3c3c] p-1 text-white">
          <ChevronDownIcon onClick={handleClose} />
        </div>
        <div className="w-full">
          <MobileTemplatesPreviewCarousel templateList={templateList} />
        </div>
      </div>
    </section>
  );
};

export default MobileResumeTemplates;
